"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Debouncer = void 0;
class Debouncer {
    constructor(callback, duration) {
        this.debounce = (...args) => {
            if (this.timeoutID) {
                window.clearTimeout(this.timeoutID);
            }
            const argList = [];
            args.forEach((element) => {
                argList.push(element);
            });
            this.timeoutID = window.setTimeout(() => {
                this.callback(...argList);
            }, this.duration);
        };
        this.clearDebounce = () => {
            if (this.timeoutID) {
                window.clearTimeout(this.timeoutID);
                this.timeoutID = undefined;
            }
        };
        this.callback = callback;
        this.duration = duration;
        this.timeoutID = undefined;
    }
}
exports.Debouncer = Debouncer;
